export default "__VITE_ASSET__6167e5ff__"